<template>
    <div>
        <a-result v-if="noFound" status="warning" :title="title" :sub-title="comment">
            <template #extra>
                <slot name="detail">
                    <a href="/"><a-button type="primary">返回首页</a-button></a>
                </slot>
            </template>
        </a-result>
        <slot v-else></slot>
    </div>
</template>

<script>
export default {
    props: { 
        'title': { default: "404" },
        'comment': String, 
        'noFound': Boolean,
    }
}
</script>

<style scoped>
.ant-result >>> .ant-result-title {
    font-size: 48px;
}
.ant-result >>> .ant-result-subtitle {
    font-size: 18px;
}
</style>